import { useState, useCallback } from "react";
import { appointmentReportService } from "../../services";

export const useAppointmentReport = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getStats = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const result = await appointmentReportService.getStats(params);
      return result.data;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const getList = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const result = await appointmentReportService.getList(params);
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const getCancelled = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const result = await appointmentReportService.getCancelled(params);
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const getWaitingList = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const result = await appointmentReportService.getWaitingList(params);
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    getStats,
    getList,
    getCancelled,
    getWaitingList,
  };
};
